import { render, staticRenderFns } from "./compte.vue?vue&type=template&id=afc74ae0&"
import script from "./compte.vue?vue&type=script&lang=js&"
export * from "./compte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports